import React from "react";
import { object, bool } from "prop-types";
import { StoryElement } from "@quintype/components";
import { DefaultStoryCard } from "../story-templates/DefaultStoryCard";
import { WithStoryAds } from "../story-templates/WithStoryAds";
import { isTemplateWithAds } from "../utils/story";

import "../story-templates/blank.m.css";

export const Mugshot = ({ card, isThumbnailRight, story, counter = {} }) => {
  const elements = card["story-elements"];
  if (elements.length > 2) {
    return <DefaultStoryCard card={card} story={story} counter={counter} />;
  }

  const textElement = elements.find((element) => element?.type === "text");
  const imageElement = elements.find((element) => element?.type === "image");

  if (!imageElement) {
    return <DefaultStoryCard card={card} story={story} counter={counter} />;
  }

  const styles = isThumbnailRight ? { float: "right", marginLeft: "16px" } : { float: "left", marginRight: "16px" };

  const enableParagraphAds = isTemplateWithAds(story);

  const componentToRender = (
    <div className="story-element story-element-mugshot" styleName="mugshot-container">
      <span style={styles} styleName="mugshot-image">
        <StoryElement element={imageElement} story={story} loadIframeOnClick />
      </span>
      <span styleName="mugshot-text">{textElement && <StoryElement element={textElement} story={story} />}</span>
    </div>
  );
  return enableParagraphAds ? (
    <WithStoryAds counter={counter} componentToRender={componentToRender} story={story} />
  ) : (
    <>{componentToRender}</>
  );
};

Mugshot.propTypes = {
  card: object,
  isThumbnailRight: bool,
  story: object,
  counter: object,
};
